import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-view-assessment-report-modal',
  templateUrl: './view-assessment-report-modal.component.html'
})
export class ViewAssessmentReportModalComponent {

  modalData: any = {};

  constructor(private bsModalRef: BsModalRef, private bsModalService: BsModalService) {
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  closeModal() {
    this.bsModalRef.hide();
  }
}
